import 'svelte/internal/disclose-version';

AdminIngest[$.FILENAME] = 'src/pages/AdminIngest.svelte';

import * as $ from 'svelte/internal/client';
import api from "../lib/api.js";
import AdminNav from "../components/AdminNav.svelte";
import FilterPane from "../components/FilterPane.svelte";
import EmptyState from "../components/EmptyState.svelte";
import { session } from "../lib/session.svelte.js";
import { relativeTime } from "../lib/format.js";
import { toastError, toastSuccess } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<p class="status bad runner-error svelte-wsj4vj"> </p>`), AdminIngest[$.FILENAME], [[258, 4]]);
var root_1 = $.add_locations($.from_html(`<option class="svelte-wsj4vj"></option>`), AdminIngest[$.FILENAME], [[282, 50]]);
var root_2 = $.add_locations($.from_html(` <strong class="svelte-wsj4vj"> </strong><!>`, 1), AdminIngest[$.FILENAME], [[312, 31]]);

var root_3 = $.add_locations(
	$.from_html(`<p class="status bad svelte-wsj4vj">Not all sources are available: <!>.
          A run will still work, but with less data than you expect.</p>`),
	AdminIngest[$.FILENAME],
	[[309, 8]]
);

var root_4 = $.add_locations($.from_html(`<div class="bar svelte-wsj4vj" role="progressbar" aria-valuemin="0"><span class="svelte-wsj4vj"></span></div>`), AdminIngest[$.FILENAME], [[345, 12, [[346, 14]]]]);
var root_5 = $.add_locations($.from_html(`<div class="bar indeterminate svelte-wsj4vj"><span class="svelte-wsj4vj"></span></div>`), AdminIngest[$.FILENAME], [[349, 12, [[349, 43]]]]);
var root_6 = $.add_locations($.from_html(`<div class="progress svelte-wsj4vj"><p class="status busy svelte-wsj4vj"><!></p> <!> <p class="counters svelte-wsj4vj"> </p></div>`), AdminIngest[$.FILENAME], [[333, 8, [[334, 10], [352, 10]]]]);
var root_7 = $.add_locations($.from_html(`<p class="status bad svelte-wsj4vj"> </p>`), AdminIngest[$.FILENAME], [[358, 8]]);
var root_8 = $.add_locations($.from_html(`<span class="bad svelte-wsj4vj"> </span>`), AdminIngest[$.FILENAME], [[366, 32]]);
var root_9 = $.add_locations($.from_html(`<p class="status svelte-wsj4vj">Last run — <strong class="svelte-wsj4vj"> </strong> <!>. <!></p>`), AdminIngest[$.FILENAME], [[361, 8, [[362, 21]]]]);

var root_10 = $.add_locations(
	$.from_html(`<section class="runner svelte-wsj4vj"><div class="row svelte-wsj4vj"><label class="svelte-wsj4vj">Town <input class="town svelte-wsj4vj" type="text" list="ingest-town-options" placeholder="Fort Lee, NJ" autocomplete="off" spellcheck="false"/> <datalist id="ingest-town-options" class="svelte-wsj4vj"></datalist></label> <label class="svelte-wsj4vj">Discover up to <input type="number" min="1" max="60" class="svelte-wsj4vj"/></label> <button class="primary svelte-wsj4vj"> </button></div> <!> <p class="hint svelte-wsj4vj"> </p> <!> <p class="hint svelte-wsj4vj">Suggestions are the towns in <code class="svelte-wsj4vj">ingest.conf</code> plus any town already in the
        catalogue — but you can type any place, such as <code class="svelte-wsj4vj">Newark, NJ</code>. A town typed here
        runs once; it is not added to the weekly job, which walks the configured list.</p> <p class="hint svelte-wsj4vj">The limit caps <strong class="svelte-wsj4vj">discovery only</strong> — how many search results are considered for
        places we don't have yet. This run does not touch the listings we already hold; refreshing
        their ratings, reviews and photos is a separate job on the <a href="/admin/refresh" class="svelte-wsj4vj">Refresh</a> page.</p> <!></section>`),
	AdminIngest[$.FILENAME],
	[
		[
			262,
			4,
			[
				[
					263,
					6,
					[
						[264, 8, [[271, 10], [281, 10]]],
						[285, 8, [[287, 10]]],
						[289, 8]
					]
				],
				[301, 6],
				[318, 6, [[319, 37], [320, 56]]],
				[324, 6, [[325, 23], [328, 8]]]
			]
		]
	]
);

var root_11 = $.add_locations($.from_html(`<p class="muted svelte-wsj4vj">Loading proposals…</p>`), AdminIngest[$.FILENAME], [[373, 4]]);
var root_12 = $.add_locations($.from_html(`<span class="warn svelte-wsj4vj"> </span> <button class="ghost svelte-wsj4vj">Cancel</button> <button class="danger svelte-wsj4vj">Yes, apply all</button>`, 1), AdminIngest[$.FILENAME], [[386, 14], [390, 14], [391, 14]]);
var root_13 = $.add_locations($.from_html(`<span class="warn svelte-wsj4vj"> </span> <button class="ghost svelte-wsj4vj">Cancel</button> <button class="danger svelte-wsj4vj">Yes, dismiss all</button>`, 1), AdminIngest[$.FILENAME], [[393, 14], [394, 14], [395, 14]]);
var root_14 = $.add_locations($.from_html(`<button class="ghost svelte-wsj4vj">Dismiss all</button> <button class="primary svelte-wsj4vj"> </button>`, 1), AdminIngest[$.FILENAME], [[397, 14], [402, 14]]);
var root_15 = $.add_locations($.from_html(`<s class="svelte-wsj4vj"> </s>`), AdminIngest[$.FILENAME], [[456, 40]]);
var root_16 = $.add_locations($.from_html(`<em class="muted svelte-wsj4vj">not set</em>`), AdminIngest[$.FILENAME], [[456, 68]]);

var root_17 = $.add_locations($.from_html(`<tr class="svelte-wsj4vj"><td class="tick svelte-wsj4vj"><input type="checkbox" class="svelte-wsj4vj"/></td><th scope="row" class="svelte-wsj4vj"> </th><td class="current svelte-wsj4vj"><!></td><td class="svelte-wsj4vj"><input type="text" class="svelte-wsj4vj"/></td></tr>`), AdminIngest[$.FILENAME], [
	[
		446,
		18,
		[
			[447, 20, [[448, 22]]],
			[454, 20],
			[455, 20],
			[458, 20, [[459, 22]]]
		]
	]
]);

var root_18 = $.add_locations($.from_html(`<article><header class="svelte-wsj4vj"><div class="svelte-wsj4vj"><h3 class="svelte-wsj4vj"> </h3> <p class="meta svelte-wsj4vj"> <a target="_blank" rel="noopener noreferrer nofollow" class="svelte-wsj4vj"> </a> </p></div> <span> </span></header> <table class="svelte-wsj4vj"><thead class="svelte-wsj4vj"><tr class="svelte-wsj4vj"><th class="tick svelte-wsj4vj"><span class="sr svelte-wsj4vj">Accept</span></th><th class="svelte-wsj4vj">Field</th><th class="svelte-wsj4vj">Currently</th><th class="svelte-wsj4vj">Proposed — editable</th></tr></thead><tbody class="svelte-wsj4vj"></tbody></table> <footer class="svelte-wsj4vj"><span class="muted svelte-wsj4vj"> </span> <div class="actions svelte-wsj4vj"><button class="ghost svelte-wsj4vj">Dismiss</button> <button class="primary svelte-wsj4vj"> </button></div></footer></article>`), AdminIngest[$.FILENAME], [
	[
		418,
		10,
		[
			[
				419,
				12,
				[[420, 14, [[421, 16], [422, 16, [[424, 18]]]]], [430, 14]]
			],

			[
				435,
				12,
				[
					[
						436,
						14,
						[
							[
								437,
								16,
								[[438, 18, [[438, 35]]], [439, 18], [440, 18], [441, 18]]
							]
						]
					],
					[444, 14]
				]
			],
			[470, 12, [[471, 14], [472, 14, [[473, 16], [476, 16]]]]]
		]
	]
]);

var root_19 = $.add_locations($.from_html(`<div class="group-head svelte-wsj4vj"><h2 class="svelte-wsj4vj"> <span class="count svelte-wsj4vj"> </span></h2> <div class="bulk svelte-wsj4vj"><!></div></div> <!>`, 1), AdminIngest[$.FILENAME], [[382, 8, [[383, 10, [[383, 28]]], [384, 10]]]]);

var root_20 = $.add_locations(
	$.from_html(
		`<!> <p class="lede svelte-wsj4vj">Findings from the weekly ingest. Nothing here has touched the live listings — tick the fields
    you want, correct anything that's wrong, then apply.</p> <!> <!> <!>`,
		1
	),
	AdminIngest[$.FILENAME],
	[[252, 2]]
);

const $$css = {
	hash: 'svelte-wsj4vj',
	code: '\n  .lede.svelte-wsj4vj { color: var(--ink-soft); font-size: 0.95rem; margin: 0 0 24px; max-width: 62ch; }\n  .muted.svelte-wsj4vj { color: var(--ink-soft); }\n  .sr.svelte-wsj4vj { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); }\n\n  .group-head.svelte-wsj4vj {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin: 30px 0 14px;\n    flex-wrap: wrap;\n  }\n  .bulk.svelte-wsj4vj { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }\n  .warn.svelte-wsj4vj { font-size: 0.85rem; color: var(--ink); font-weight: 600; }\n  .danger.svelte-wsj4vj { background: #b3261e; color: #fff; border: 1px solid #b3261e; }\n  .danger.svelte-wsj4vj:hover { filter: brightness(1.08); }\n\n  h2.svelte-wsj4vj { font-size: 1.05rem; margin: 0; display: flex; align-items: center; gap: 9px; }\n  .count.svelte-wsj4vj {\n    background: var(--card-soft);\n    border: 1px solid var(--line);\n    border-radius: var(--radius-pill);\n    padding: 1px 10px;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: var(--ink-soft);\n  }\n\n  .card.svelte-wsj4vj {\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    padding: 18px 20px;\n    margin-bottom: 14px;\n    transition: opacity 0.15s ease;\n  }\n  .card.busy.svelte-wsj4vj { opacity: 0.55; pointer-events: none; }\n\n  .card.svelte-wsj4vj header:where(.svelte-wsj4vj) { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; flex-wrap: wrap; }\n  .card.svelte-wsj4vj h3:where(.svelte-wsj4vj) { font-size: 1.05rem; margin: 0; }\n  .meta.svelte-wsj4vj { margin: 3px 0 0; font-size: 0.85rem; color: var(--ink-soft); }\n  .meta.svelte-wsj4vj a:where(.svelte-wsj4vj) { text-decoration: underline; }\n\n  .pill.svelte-wsj4vj {\n    border: 1px solid var(--line);\n    border-radius: var(--radius-pill);\n    padding: 3px 12px;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: var(--ink-soft);\n    white-space: nowrap;\n  }\n  .pill.new.svelte-wsj4vj { border-color: var(--accent); color: var(--accent); }\n\n  table.svelte-wsj4vj { width: 100%; border-collapse: collapse; margin: 14px 0 4px; font-size: 0.88rem; }\n  th.svelte-wsj4vj, td.svelte-wsj4vj { text-align: left; padding: 7px 10px 7px 0; vertical-align: middle; }\n  thead.svelte-wsj4vj th:where(.svelte-wsj4vj) { font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.04em; color: var(--ink-soft); font-weight: 600; }\n  tbody.svelte-wsj4vj tr:where(.svelte-wsj4vj) { border-top: 1px solid var(--line); }\n  tbody.svelte-wsj4vj th:where(.svelte-wsj4vj) { font-weight: 600; width: 22%; }\n  .tick.svelte-wsj4vj { width: 34px; }\n  .current.svelte-wsj4vj { width: 30%; color: var(--ink-soft); word-break: break-word; }\n  .current.svelte-wsj4vj s:where(.svelte-wsj4vj) { text-decoration-color: var(--ink-soft); }\n\n  input[type="text"].svelte-wsj4vj {\n    width: 100%;\n    padding: 6px 9px;\n    border: 1px solid var(--line);\n    border-radius: 7px;\n    background: var(--card-soft);\n    color: var(--ink);\n    font: inherit;\n  }\n  input[type="text"].svelte-wsj4vj:disabled { opacity: 0.45; }\n\n  .card.svelte-wsj4vj footer:where(.svelte-wsj4vj) {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding-top: 12px;\n    border-top: 1px solid var(--line);\n    font-size: 0.85rem;\n    flex-wrap: wrap;\n  }\n  .actions.svelte-wsj4vj { display: flex; gap: 8px; }\n  button.svelte-wsj4vj { border-radius: var(--radius-pill); padding: 8px 18px; font-size: 0.87rem; font-weight: 600; cursor: pointer; }\n  .primary.svelte-wsj4vj { background: var(--accent); color: #fff; border: 1px solid var(--accent); }\n  .ghost.svelte-wsj4vj { background: transparent; color: var(--ink-soft); border: 1px solid var(--line); }\n  .ghost.svelte-wsj4vj:hover { color: var(--ink); background: var(--card-soft); }\n  button.svelte-wsj4vj:disabled { opacity: 0.5; cursor: not-allowed; }\n\n  @media (max-width: 640px) {\n    table.svelte-wsj4vj, thead.svelte-wsj4vj, tbody.svelte-wsj4vj, tr.svelte-wsj4vj, th.svelte-wsj4vj, td.svelte-wsj4vj { display: block; }\n    thead.svelte-wsj4vj { display: none; }\n    tbody.svelte-wsj4vj tr:where(.svelte-wsj4vj) { padding: 10px 0; }\n    tbody.svelte-wsj4vj th:where(.svelte-wsj4vj), .current.svelte-wsj4vj, .tick.svelte-wsj4vj { width: auto; }\n  }\n\n  .runner.svelte-wsj4vj {\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    background: var(--card);\n    padding: 16px 18px;\n    margin-bottom: 22px;\n  }\n  .runner.svelte-wsj4vj .row:where(.svelte-wsj4vj) { display: flex; gap: 14px; align-items: flex-end; flex-wrap: wrap; }\n  .runner.svelte-wsj4vj label:where(.svelte-wsj4vj) {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    font-size: 0.78rem;\n    font-weight: 600;\n    color: var(--ink-soft);\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n  /* (unused) .runner select,*/\n  .runner.svelte-wsj4vj input:where(.svelte-wsj4vj) {\n    padding: 8px 10px;\n    border: 1px solid var(--line);\n    border-radius: 8px;\n    background: var(--card-soft);\n    color: var(--ink);\n    font: inherit;\n    text-transform: none;\n    letter-spacing: normal;\n  }\n  .runner.svelte-wsj4vj input:where(.svelte-wsj4vj) { width: 90px; }\n  .runner.svelte-wsj4vj input.town:where(.svelte-wsj4vj) { width: 220px; }\n  .runner.svelte-wsj4vj .hint:where(.svelte-wsj4vj) { margin: 12px 0 0; font-size: 0.82rem; color: var(--ink-soft); max-width: 68ch; line-height: 1.5; }\n  .runner.svelte-wsj4vj .status:where(.svelte-wsj4vj) { margin: 10px 0 0; font-size: 0.85rem; }\n  .progress.svelte-wsj4vj { margin-top: 12px; }\n  .bar.svelte-wsj4vj {\n    height: 6px;\n    border-radius: 3px;\n    background: var(--card-soft);\n    border: 1px solid var(--line);\n    overflow: hidden;\n    margin: 8px 0 6px;\n  }\n  .bar.svelte-wsj4vj span:where(.svelte-wsj4vj) { display: block; height: 100%; background: var(--accent); transition: width 0.4s ease; }\n  /* No countable total during discovery — sweep instead of faking a percentage. */\n  .bar.indeterminate.svelte-wsj4vj span:where(.svelte-wsj4vj) { width: 35%; animation: svelte-wsj4vj-sweep 1.3s ease-in-out infinite; }\n  @keyframes svelte-wsj4vj-sweep {\n    0% { margin-left: -35%; }\n    100% { margin-left: 100%; }\n  }\n  .counters.svelte-wsj4vj { margin: 0; font-size: 0.78rem; color: var(--ink-soft); font-variant-numeric: tabular-nums; }\n  .runner.svelte-wsj4vj .status.busy:where(.svelte-wsj4vj) { color: var(--accent); font-weight: 600; }\n  .runner.svelte-wsj4vj .status:where(.svelte-wsj4vj) .bad:where(.svelte-wsj4vj), .runner.svelte-wsj4vj .status.bad:where(.svelte-wsj4vj) { color: #b3261e; font-weight: 600; }\n  .runner-error.svelte-wsj4vj {\n    border: 1px solid #b3261e;\n    border-radius: var(--radius);\n    padding: 12px 16px;\n    margin-bottom: 18px;\n  }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function AdminIngest($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, AdminIngest);
	$.append_styles($$anchor, $$css);

	const FIELD_LABELS = {
		name: "Name",
		cuisine: "Cuisine",
		address: "Address",
		city: "City",
		state: "State",
		postalCode: "Postcode",
		phone: "Phone",
		website: "Website",
		priceLevel: "Price level",
		tags: "Tags"
	};

	let proposals = $.tag($.state($.proxy([])), 'proposals');
	let loading = $.tag($.state(true), 'loading');
	let busy = $.tag($.state(null), 'busy');

	// Per-proposal reviewer state: which fields are ticked, and any hand-edited value.
	// A reviewer who corrects a value before accepting is entering their own data, not the
	// provider's — which is exactly the point of the queue.
	let accepted = $.tag($.state($.proxy({})), 'accepted');

	let edits = $.tag($.state($.proxy({})), 'edits');
	const isAdmin = $.tag($.derived(() => $.strict_equals(session.user?.role, "admin")), 'isAdmin');
	const newPlaces = $.tag($.derived(() => $.get(proposals).filter((p) => $.strict_equals(p.kind, "new"))), 'newPlaces');
	const updates = $.tag($.derived(() => $.get(proposals).filter((p) => $.strict_equals(p.kind, "update"))), 'updates');

	async function reload() {
		$.set(loading, true);

		try {
			const rows = (await $.track_reactivity_loss(api.stagedUpdates()))();

			$.set(proposals, rows, true);

			// Default to accepting everything the provider proposed; the reviewer unticks what's wrong.
			$.set(
				accepted,
				Object.fromEntries(rows.map((p) => [
					p.id,
					Object.fromEntries(p.diffs.map((d) => [d.field, true]))
				])),
				true
			);

			$.set(
				edits,
				Object.fromEntries(rows.map((p) => [
					p.id,
					Object.fromEntries(p.diffs.map((d) => [d.field, d.proposed ?? ""]))
				])),
				true
			);
		} catch(error) {
			toastError(error.message);
		} finally {
			$.set(loading, false);
		}
	}

	$.user_effect(() => {
		if (!$.get(isAdmin)) return;

		reload();
		refreshStatus();

		// The catalogue's own towns are the useful half of the town suggestions, and its cuisines are
		// the runner's filter vocabulary. Failures are silent: they only cost suggestions.
		api.facets().then((f) => $.set(facets, { cuisines: f.cuisines ?? [], cities: f.cities ?? [] }, true)).catch(() => {});

		// Stop polling when the page goes away, or a background timer outlives it.
		return () => {
			if (poll) clearInterval(poll);

			poll = null;
		};
	});

	function remove(id) {
		$.set(proposals, $.get(proposals).filter((p) => $.strict_equals(p.id, id, false)), true);
	}

	function selectedFields(proposal) {
		const ticks = $.get(accepted)[proposal.id] ?? {};
		const values = $.get(edits)[proposal.id] ?? {};

		return Object.fromEntries(proposal.diffs.filter((d) => ticks[d.field]).map((d) => [d.field, values[d.field] ?? ""]));
	}

	function selectedCount(proposal) {
		return Object.keys(selectedFields(proposal)).length;
	}

	async function apply(proposal) {
		const fields = selectedFields(proposal);

		if ($.strict_equals(Object.keys(fields).length, 0)) {
			toastError("Tick at least one field, or reject the proposal.");

			return;
		}

		$.set(busy, proposal.id, true);

		try {
			(await $.track_reactivity_loss(api.applyStaged(proposal.id, fields, null)))();
			remove(proposal.id);

			toastSuccess($.strict_equals(proposal.kind, "new")
				? `Added ${fields.name ?? proposal.displayName}.`
				: `Updated ${proposal.displayName}.`);
		} catch(error) {
			toastError(error.message ?? "Couldn't apply that proposal.");
		} finally {
			$.set(busy, null);
		}
	}

	// Bulk actions are two-step: the button arms, then a second click commits. A single stray
	// click must not write hundreds of listings.
	let arming = $.tag($.state(null), 'arming');

	let bulkBusy = $.tag($.state(null), 'bulkBusy');

	// --- run an ingest from here -------------------------------------------------
	let towns = $.tag($.state($.proxy([] // what ingest.conf configures
	)), 'towns');

	let facets = $.tag($.state($.proxy({ cuisines: [], cities: [] })), 'facets');
	let town = $.tag($.state(""), 'town');
	let limit = $.tag($.state(20), 'limit');
	let selection = $.tag($.state($.proxy({ cuisine: [], city: [], price: [], rating: [] })), 'selection');
	let ingest = $.tag($.state(null), 'ingest');
	let starting = $.tag($.state(false), 'starting');
	let ingestUnavailable = $.tag($.state(null), 'ingestUnavailable');
	let loaded = $.tag($.state(false), 'loaded');
	let sources = $.tag($.state($.proxy([])), 'sources');
	let poll = null;
	const running = $.tag($.derived(() => $.strict_equals($.get(ingest)?.running, true)), 'running');
	const catalogueTowns = $.tag($.derived(() => ($.get(facets).cities ?? []).map((c) => c.value)), 'catalogueTowns');

	/**
	 * Suggestions for the town field: the configured towns first, then any town already in the
	 * catalogue. The second half matters — places from towns nobody configured are in there,
	 * because a neighbouring town's search returns them, and those should be runnable without
	 * editing `ingest.conf`.
	 */
	const townOptions = $.tag($.derived(() => [...new Set([...$.get(towns), ...$.get(catalogueTowns)])].filter((t) => t?.trim())), 'townOptions');

	/**
	 * The pane's selection reduced to what the run sends.
	 *
	 * Checked rating boxes are thresholds, so OR-ing them means the lowest one; "…or less" price
	 * boxes are ceilings, so the loosest one names the levels Google is given. Neither is a filter
	 * over rows we hold — Google applies them to what it returns.
	 */
	const filterSelection = $.tag(
		$.derived(() => ({
			cuisines: $.get(selection).cuisine,
			minRating: $.get(selection).rating.length
				? Math.min(...$.get(selection).rating.map(Number))
				: null,

			priceLevels: $.get(selection).price.length
				? Array.from({ length: Math.max(...$.get(selection).price.map(Number)) }, (_, i) => i + 1)
				: []
		})),
		'filterSelection'
	);

	/** One provider search per cuisine; the discovery limit applies to each of them. */
	const searchCount = $.tag($.derived(() => Math.max(1, $.get(selection).cuisine.length)), 'searchCount');

	function updateSelection(patch) {
		$.set(selection, { ...$.get(selection), ...patch }, true);
	}

	async function refreshStatus() {
		try {
			const response = (await $.track_reactivity_loss(api.ingestStatus()))();

			$.set(towns, response.towns ?? [], true);
			$.set(sources, response.sources ?? [], true);

			if (!$.get(town) && $.get(towns).length) $.set(town, $.get(towns)[0], true);

			$.set(ingest, response.status, true);
			$.set(loaded, true);

			if ($.get(ingest)?.running && !poll) {
				// Fast enough that the counter visibly moves; the payload is a few hundred bytes.
				poll = setInterval(refreshStatus, 1000);
			} else if (!$.get(ingest)?.running && poll) {
				clearInterval(poll);
				poll = null;

				// A finished run has usually staged something; pull the queue again.
				(await $.track_reactivity_loss(reload()))();
			}
		} catch(error) {
			// Don't swallow this. A missing panel with no explanation is exactly how a misconfigured
			// server looks like a UI bug.
			$.set(ingestUnavailable, error.message ?? "Ingest status unavailable.", true);

			if (poll) {
				clearInterval(poll);
				poll = null;
			}
		}
	}

	async function startIngest() {
		$.set(starting, true);

		try {
			(await $.track_reactivity_loss(api.runIngest($.get(town), Number($.get(limit)), true, $.get(filterSelection))))();
			toastSuccess(`Ingesting ${$.get(town)}…`);
			(await $.track_reactivity_loss(refreshStatus()))();
		} catch(error) {
			toastError(error.message ?? "Couldn't start the ingest.");
		} finally {
			$.set(starting, false);
		}
	}

	async function bulk(action, kind, count) {
		const key = `${action}:${kind}`;

		if ($.strict_equals($.get(arming), key, false)) {
			$.set(arming, key);

			return;
		}

		$.set(arming, null);
		$.set(bulkBusy, key);

		try {
			const result = $.strict_equals(action, "apply")
				? (await $.track_reactivity_loss(api.applyAllStaged(kind)))()
				: (await $.track_reactivity_loss(api.rejectAllStaged(kind, null)))();

			$.set(proposals, $.get(proposals).filter((p) => $.strict_equals(p.kind, kind, false)), true);

			const verb = $.strict_equals(action, "apply") ? "Added" : "Dismissed";

			if (result.failed?.length) {
				toastError(`${verb} ${result.applied}. ${result.failed.length} could not be applied.`);
			} else {
				toastSuccess(`${verb} ${result.applied} ${$.strict_equals(result.applied, 1) ? "listing" : "listings"}.`);
			}
		} catch(error) {
			toastError(error.message ?? "Bulk action failed.");
		} finally {
			$.set(bulkBusy, null);
		}
	}

	async function reject(proposal) {
		$.set(busy, proposal.id, true);

		try {
			(await $.track_reactivity_loss(api.rejectStaged(proposal.id, null)))();
			remove(proposal.id);
			toastSuccess("Proposal dismissed.");
		} catch(error) {
			toastError(error.message ?? "Couldn't dismiss that proposal.");
		} finally {
			$.set(busy, null);
		}
	}

	var $$exports = { ...$.legacy_api() };
	var fragment = $.comment();

	$.head('wsj4vj', ($$anchor) => {
		$.effect(() => {
			$.document.title = 'Ingest review · Upsorok admin';
		});
	});

	var node = $.first_child(fragment);

	{
		var consequent = ($$anchor) => {
			$.add_svelte_meta(
				() => EmptyState($$anchor, {
					title: 'Admins only',
					body: 'You need an admin account to review ingested data.'
				}),
				'component',
				AdminIngest,
				248,
				2,
				{ componentTag: 'EmptyState' }
			);
		};

		var alternate_5 = ($$anchor) => {
			var fragment_2 = root_20();
			var node_1 = $.first_child(fragment_2);

			$.add_svelte_meta(() => AdminNav(node_1, { current: 'ingest' }), 'component', AdminIngest, 250, 2, { componentTag: 'AdminNav' });

			var node_2 = $.sibling(node_1, 4);

			{
				var consequent_1 = ($$anchor) => {
					var p_1 = root();
					var text = $.child(p_1);

					$.reset(p_1);
					$.template_effect(() => $.set_text(text, `Can't run an ingest from here: ${$.get(ingestUnavailable) ?? ''}`));
					$.append($$anchor, p_1);
				};

				$.add_svelte_meta(
					() => $.if(node_2, ($$render) => {
						if ($.get(ingestUnavailable)) $$render(consequent_1);
					}),
					'if',
					AdminIngest,
					257,
					2
				);
			}

			var node_3 = $.sibling(node_2, 2);

			{
				var consequent_12 = ($$anchor) => {
					var section = root_10();
					var div = $.child(section);
					var label = $.child(div);
					var input = $.sibling($.child(label));

					$.remove_input_defaults(input);

					var datalist = $.sibling(input, 2);

					$.add_svelte_meta(
						() => $.each(datalist, 20, () => $.get(townOptions), (option) => option, ($$anchor, option) => {
							var option_1 = root_1();
							var option_1_value = {};

							$.template_effect(() => {
								if (option_1_value !== (option_1_value = option)) {
									option_1.value = (option_1.__value = option) ?? '';
								}
							});

							$.append($$anchor, option_1);
						}),
						'each',
						AdminIngest,
						282,
						12
					);

					$.reset(datalist);
					$.reset(label);

					var label_1 = $.sibling(label, 2);
					var input_1 = $.sibling($.child(label_1));

					$.remove_input_defaults(input_1);
					$.reset(label_1);

					var button = $.sibling(label_1, 2);
					var text_1 = $.child(button, true);

					$.reset(button);
					$.reset(div);

					var node_4 = $.sibling(div, 2);

					$.add_svelte_meta(
						() => FilterPane(node_4, {
							get facets() {
								return $.get(facets);
							},

							get selection() {
								return $.get(selection);
							},
							showTowns: false,
							onchange: updateSelection
						}),
						'component',
						AdminIngest,
						299,
						6,
						{ componentTag: 'FilterPane' }
					);

					var p_2 = $.sibling(node_4, 2);
					var text_2 = $.child(p_2);

					$.reset(p_2);

					var node_5 = $.sibling(p_2, 2);

					{
						var consequent_3 = ($$anchor) => {
							var p_3 = root_3();
							var node_6 = $.sibling($.child(p_3));

							$.add_svelte_meta(
								() => $.each(node_6, 17, () => $.get(sources).filter((s) => s.enabled && !s.usable), $.index, ($$anchor, s, i) => {
									$.next();

									var fragment_3 = root_2();
									var text_3 = $.first_child(fragment_3, true);

									text_3.nodeValue = i > 0 ? ", " : "";

									var strong = $.sibling(text_3);
									var text_4 = $.child(strong, true);

									$.reset(strong);

									var node_7 = $.sibling(strong);

									{
										var consequent_2 = ($$anchor) => {
											var text_5 = $.text();

											$.template_effect(() => $.set_text(text_5, `(set ${$.get(s).requiresEnv ?? ''})`));
											$.append($$anchor, text_5);
										};

										$.add_svelte_meta(
											() => $.if(node_7, ($$render) => {
												if ($.get(s).requiresEnv) $$render(consequent_2);
											}),
											'if',
											AdminIngest,
											312,
											58
										);
									}

									$.template_effect(() => $.set_text(text_4, $.get(s).source));
									$.append($$anchor, fragment_3);
								}),
								'each',
								AdminIngest,
								311,
								10
							);

							$.next();
							$.reset(p_3);
							$.append($$anchor, p_3);
						};

						var d_1 = $.derived(() => $.get(sources).some((s) => s.enabled && !s.usable));

						$.add_svelte_meta(
							() => $.if(node_5, ($$render) => {
								if ($.get(d_1)) $$render(consequent_3);
							}),
							'if',
							AdminIngest,
							308,
							6
						);
					}

					var node_8 = $.sibling(node_5, 6);

					{
						var consequent_7 = ($$anchor) => {
							const p = $.tag($.derived(() => $.get(ingest).progress), 'p');

							$.get(p);

							var div_1 = root_6();
							var p_4 = $.child(div_1);
							var node_9 = $.child(p_4);

							{
								var consequent_4 = ($$anchor) => {
									var text_6 = $.text();

									$.template_effect(() => $.set_text(text_6, `Discovering — ${$.get(p).detail ?? ''}`));
									$.append($$anchor, text_6);
								};

								var consequent_5 = ($$anchor) => {
									var text_7 = $.text('Saving proposals and caching photos…');

									$.append($$anchor, text_7);
								};

								var alternate = ($$anchor) => {
									var text_8 = $.text();

									$.template_effect(() => $.set_text(text_8, `Starting ingest of ${$.get(ingest).town ?? ''}…`));
									$.append($$anchor, text_8);
								};

								$.add_svelte_meta(
									() => $.if(node_9, ($$render) => {
										if ($.strict_equals($.get(p)?.phase, "discovering")) $$render(consequent_4); else if ($.strict_equals($.get(p)?.phase, "saving")) $$render(consequent_5, 1); else $$render(alternate, -1);
									}),
									'if',
									AdminIngest,
									335,
									12
								);
							}

							$.reset(p_4);

							var node_10 = $.sibling(p_4, 2);

							{
								var consequent_6 = ($$anchor) => {
									var div_2 = root_4();
									var span = $.child(div_2);

									$.reset(div_2);

									$.template_effect(
										($0) => {
											$.set_attribute(div_2, 'aria-valuenow', $.get(p).done);
											$.set_attribute(div_2, 'aria-valuemax', $.get(p).total);
											$.set_style(span, `width: ${$0 ?? ''}%`);
										},
										[() => Math.round($.get(p).done / $.get(p).total * 100)]
									);

									$.append($$anchor, div_2);
								};

								var alternate_1 = ($$anchor) => {
									var div_3 = root_5();

									$.append($$anchor, div_3);
								};

								$.add_svelte_meta(
									() => $.if(node_10, ($$render) => {
										if ($.get(p)?.total) $$render(consequent_6); else $$render(alternate_1, -1);
									}),
									'if',
									AdminIngest,
									344,
									10
								);
							}

							var p_5 = $.sibling(node_10, 2);
							var text_9 = $.child(p_5);

							$.reset(p_5);
							$.reset(div_1);

							$.template_effect(() => $.set_text(text_9, `${$.get(p)?.placesFound ?? 0 ?? ''} place${$.strict_equals($.get(p)?.placesFound ?? 0, 1) ? "" : "s"} fetched
            · ${$.get(p)?.apiCalls ?? 0 ?? ''} API call${$.strict_equals($.get(p)?.apiCalls ?? 0, 1) ? "" : "s"}`));

							$.append($$anchor, div_1);
						};

						var consequent_8 = ($$anchor) => {
							var p_6 = root_7();
							var text_10 = $.child(p_6);

							$.reset(p_6);
							$.template_effect(() => $.set_text(text_10, `Last run failed: ${$.get(ingest).error ?? ''}`));
							$.append($$anchor, p_6);
						};

						var consequent_11 = ($$anchor) => {
							const o = $.tag($.derived(() => $.get(ingest).outcome), 'o');

							$.get(o);

							var p_7 = root_9();
							var strong_1 = $.sibling($.child(p_7));
							var text_11 = $.child(strong_1, true);

							$.reset(strong_1);

							var text_12 = $.sibling(strong_1);
							var node_11 = $.sibling(text_12);

							{
								var consequent_9 = ($$anchor) => {
									var text_13 = $.text();

									$.template_effect(($0) => $.set_text(text_13, `(via ${$0 ?? ''})`), [() => $.get(o).sourcesUsed.join(", ")]);
									$.append($$anchor, text_13);
								};

								$.add_svelte_meta(
									() => $.if(node_11, ($$render) => {
										if ($.get(o).sourcesUsed?.length) $$render(consequent_9);
									}),
									'if',
									AdminIngest,
									365,
									10
								);
							}

							var node_12 = $.sibling(node_11, 2);

							{
								var consequent_10 = ($$anchor) => {
									var span_1 = root_8();
									var text_14 = $.child(span_1);

									$.reset(span_1);
									$.template_effect(() => $.set_text(text_14, `${$.get(o).errors.length ?? ''} error(s).`));
									$.append($$anchor, span_1);
								};

								$.add_svelte_meta(
									() => $.if(node_12, ($$render) => {
										if ($.get(o).errors?.length) $$render(consequent_10);
									}),
									'if',
									AdminIngest,
									366,
									10
								);
							}

							$.reset(p_7);

							$.template_effect(() => {
								$.set_text(text_11, $.get(o).town);

								$.set_text(text_12, `:
          ${$.get(o).discovered ?? ''} new, ${$.get(o).proposalsStaged ?? ''} staged for review,
          ${$.get(o).excerptsCached ?? ''} excerpts, ${$.get(o).apiCalls ?? ''} API calls `);
							});

							$.append($$anchor, p_7);
						};

						$.add_svelte_meta(
							() => $.if(node_8, ($$render) => {
								if ($.get(ingest)?.running) $$render(consequent_7); else if ($.get(ingest)?.error) $$render(consequent_8, 1); else if ($.get(ingest)?.outcome) $$render(consequent_11, 2);
							}),
							'if',
							AdminIngest,
							331,
							6
						);
					}

					$.reset(section);

					$.template_effect(() => {
						input.disabled = $.get(running);
						input_1.disabled = $.get(running);
						button.disabled = $.get(running) || $.get(starting) || !$.get(town);
						$.set_text(text_1, $.get(running) ? "Running…" : "Ingest this town");

						$.set_text(text_2, `Filters travel with the search, so they narrow what Google returns rather than the listings
        we already hold — the rating included, which is Google's own. A cuisine selection is one
        search per cuisine: ${$.get(searchCount) ?? ''} search${$.strict_equals($.get(searchCount), 1) ? "" : "es"} of up to ${$.get(limit) ?? ''}
        results each.`);
					});

					$.bind_value(
						input,
						function get() {
							return $.get(town);
						},
						function set($$value) {
							$.set(town, $$value);
						}
					);

					$.bind_value(
						input_1,
						function get() {
							return $.get(limit);
						},
						function set($$value) {
							$.set(limit, $$value);
						}
					);

					$.delegated('click', button, startIngest);
					$.append($$anchor, section);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if (!$.get(ingestUnavailable) && $.get(loaded)) $$render(consequent_12);
					}),
					'if',
					AdminIngest,
					261,
					2
				);
			}

			var node_13 = $.sibling(node_3, 2);

			{
				var consequent_13 = ($$anchor) => {
					var p_8 = root_11();

					$.append($$anchor, p_8);
				};

				var consequent_14 = ($$anchor) => {
					$.add_svelte_meta(
						() => EmptyState($$anchor, {
							title: 'Nothing to review',
							body: 'The last ingest found no differences. Run ./scripts/weekly-ingest.sh to check again.'
						}),
						'component',
						AdminIngest,
						375,
						4,
						{ componentTag: 'EmptyState' }
					);
				};

				var alternate_4 = ($$anchor) => {
					var fragment_9 = $.comment();
					var node_14 = $.first_child(fragment_9);

					$.add_svelte_meta(
						() => $.each(
							node_14,
							17,
							() => [
								{ label: "New places", kind: "new", rows: $.get(newPlaces) },
								{
									label: "Changes to existing listings",
									kind: "update",
									rows: $.get(updates)
								}
							],
							$.index,
							($$anchor, group) => {
								var fragment_10 = $.comment();
								var node_15 = $.first_child(fragment_10);

								{
									var consequent_18 = ($$anchor) => {
										var fragment_11 = root_19();
										var div_4 = $.first_child(fragment_11);
										var h2 = $.child(div_4);
										var text_15 = $.child(h2);
										var span_2 = $.sibling(text_15);
										var text_16 = $.child(span_2, true);

										$.reset(span_2);
										$.reset(h2);

										var div_5 = $.sibling(h2, 2);
										var node_16 = $.child(div_5);

										{
											var consequent_15 = ($$anchor) => {
												var fragment_12 = root_12();
												var span_3 = $.first_child(fragment_12);
												var text_17 = $.child(span_3);

												$.reset(span_3);

												var button_1 = $.sibling(span_3, 2);
												var button_2 = $.sibling(button_1, 2);

												$.template_effect(() => $.set_text(text_17, `${$.strict_equals($.get(group).kind, "new") ? "Add" : "Apply"} all ${$.get(group).rows.length ?? ''}?
                Everything each provider proposed, unreviewed.`));

												$.delegated('click', button_1, function click() {
													return $.set(arming, null);
												});

												$.delegated('click', button_2, function click_1() {
													return bulk("apply", $.get(group).kind);
												});

												$.append($$anchor, fragment_12);
											};

											var consequent_16 = ($$anchor) => {
												var fragment_13 = root_13();
												var span_4 = $.first_child(fragment_13);
												var text_18 = $.child(span_4);

												$.reset(span_4);

												var button_3 = $.sibling(span_4, 2);
												var button_4 = $.sibling(button_3, 2);

												$.template_effect(() => $.set_text(text_18, `Dismiss all ${$.get(group).rows.length ?? ''}?`));

												$.delegated('click', button_3, function click_2() {
													return $.set(arming, null);
												});

												$.delegated('click', button_4, function click_3() {
													return bulk("reject", $.get(group).kind);
												});

												$.append($$anchor, fragment_13);
											};

											var alternate_2 = ($$anchor) => {
												var fragment_14 = root_14();
												var button_5 = $.first_child(fragment_14);
												var button_6 = $.sibling(button_5, 2);
												var text_19 = $.child(button_6, true);

												$.reset(button_6);

												$.template_effect(() => {
													button_5.disabled = $.strict_equals($.get(bulkBusy), null, false);
													button_6.disabled = $.strict_equals($.get(bulkBusy), null, false);

													$.set_text(text_19, $.strict_equals($.get(bulkBusy), `apply:${$.get(group).kind}`)
														? "Working…"
														: $.strict_equals($.get(group).kind, "new")
															? `Add all ${$.get(group).rows.length}`
															: `Apply all ${$.get(group).rows.length}`);
												});

												$.delegated('click', button_5, function click_4() {
													return bulk("reject", $.get(group).kind);
												});

												$.delegated('click', button_6, function click_5() {
													return bulk("apply", $.get(group).kind);
												});

												$.append($$anchor, fragment_14);
											};

											$.add_svelte_meta(
												() => $.if(node_16, ($$render) => {
													if ($.strict_equals($.get(arming), `apply:${$.get(group).kind}`)) $$render(consequent_15); else if ($.strict_equals($.get(arming), `reject:${$.get(group).kind}`)) $$render(consequent_16, 1); else $$render(alternate_2, -1);
												}),
												'if',
												AdminIngest,
												385,
												12
											);
										}

										$.reset(div_5);
										$.reset(div_4);

										var node_17 = $.sibling(div_4, 2);

										$.add_svelte_meta(
											() => $.each(node_17, 17, () => $.get(group).rows, (proposal) => proposal.id, ($$anchor, proposal) => {
												var article = root_18();
												let classes;
												var header = $.child(article);
												var div_6 = $.child(header);
												var h3 = $.child(div_6);
												var text_20 = $.child(h3, true);

												$.reset(h3);

												var p_9 = $.sibling(h3, 2);
												var text_21 = $.child(p_9);
												var a = $.sibling(text_21);
												var text_22 = $.child(a, true);

												$.reset(a);

												var text_23 = $.sibling(a);

												$.reset(p_9);
												$.reset(div_6);

												var span_5 = $.sibling(div_6, 2);
												let classes_1;
												var text_24 = $.child(span_5, true);

												$.reset(span_5);
												$.reset(header);

												var table = $.sibling(header, 2);
												var tbody = $.sibling($.child(table));

												$.add_svelte_meta(
													() => $.each(tbody, 21, () => $.get(proposal).diffs, (diff) => diff.field, ($$anchor, diff) => {
														var tr = root_17();
														var td = $.child(tr);
														var input_2 = $.child(td);

														$.remove_input_defaults(input_2);
														$.validate_binding('bind:checked={accepted[proposal.id][diff.field]}', [], () => $.get(accepted)[$.get(proposal).id], () => $.get(diff).field, 450, 24);
														$.reset(td);

														var th = $.sibling(td);
														var text_25 = $.child(th, true);

														$.reset(th);

														var td_1 = $.sibling(th);
														var node_18 = $.child(td_1);

														{
															var consequent_17 = ($$anchor) => {
																var s_1 = root_15();
																var text_26 = $.child(s_1, true);

																$.reset(s_1);
																$.template_effect(() => $.set_text(text_26, $.get(diff).current));
																$.append($$anchor, s_1);
															};

															var alternate_3 = ($$anchor) => {
																var em = root_16();

																$.append($$anchor, em);
															};

															$.add_svelte_meta(
																() => $.if(node_18, ($$render) => {
																	if ($.get(diff).current) $$render(consequent_17); else $$render(alternate_3, -1);
																}),
																'if',
																AdminIngest,
																456,
																22
															);
														}

														$.reset(td_1);

														var td_2 = $.sibling(td_1);
														var input_3 = $.child(td_2);

														$.remove_input_defaults(input_3);
														$.validate_binding('bind:value={edits[proposal.id][diff.field]}', [], () => $.get(edits)[$.get(proposal).id], () => $.get(diff).field, 461, 24);
														$.reset(td_2);
														$.reset(tr);

														$.template_effect(() => {
															$.set_attribute(input_2, 'aria-label', `Accept ${FIELD_LABELS[$.get(diff).field] ?? $.get(diff).field}`);
															$.set_text(text_25, FIELD_LABELS[$.get(diff).field] ?? $.get(diff).field);
															input_3.disabled = !$.get(accepted)[$.get(proposal).id][$.get(diff).field];
														});

														$.bind_checked(
															input_2,
															function get() {
																return $.get(accepted)[$.get(proposal).id][$.get(diff).field];
															},
															function set($$value) {
																$.get(accepted)[$.get(proposal).id][$.get(diff).field] = $$value;
															}
														);

														$.bind_value(
															input_3,
															function get() {
																return $.get(edits)[$.get(proposal).id][$.get(diff).field];
															},
															function set($$value) {
																$.get(edits)[$.get(proposal).id][$.get(diff).field] = $$value;
															}
														);

														$.append($$anchor, tr);
													}),
													'each',
													AdminIngest,
													445,
													16
												);

												$.reset(tbody);
												$.reset(table);

												var footer = $.sibling(table, 2);
												var span_6 = $.child(footer);
												var text_27 = $.child(span_6);

												$.reset(span_6);

												var div_7 = $.sibling(span_6, 2);
												var button_7 = $.child(div_7);
												var button_8 = $.sibling(button_7, 2);
												var text_28 = $.child(button_8, true);

												$.reset(button_8);
												$.reset(div_7);
												$.reset(footer);
												$.reset(article);

												$.template_effect(
													($0, $1) => {
														classes = $.set_class(article, 1, 'card svelte-wsj4vj', null, classes, { busy: $.strict_equals($.get(busy), $.get(proposal).id) });
														$.set_text(text_20, $.get(proposal).displayName);
														$.set_text(text_21, `${$.get(proposal).city ?? ''} · `);
														$.set_attribute(a, 'href', $.get(proposal).sourceUrl);
														$.set_text(text_22, $.get(proposal).source);
														$.set_text(text_23, ` · fetched ${$0 ?? ''}`);
														classes_1 = $.set_class(span_5, 1, 'pill svelte-wsj4vj', null, classes_1, { new: $.strict_equals($.get(proposal).kind, "new") });

														$.set_text(text_24, $.strict_equals($.get(proposal).kind, "new")
															? "Not listed yet"
															: `${$.get(proposal).diffs.length} field(s) differ`);

														$.set_text(text_27, `${$1 ?? ''} of ${$.get(proposal).diffs.length ?? ''} selected`);
														button_7.disabled = $.strict_equals($.get(busy), $.get(proposal).id);
														button_8.disabled = $.strict_equals($.get(busy), $.get(proposal).id);
														$.set_text(text_28, $.strict_equals($.get(proposal).kind, "new") ? "Add restaurant" : "Apply selected");
													},
													[
														() => relativeTime($.get(proposal).fetchedAt),
														() => selectedCount($.get(proposal))
													]
												);

												$.delegated('click', button_7, function click_6() {
													return reject($.get(proposal));
												});

												$.delegated('click', button_8, function click_7() {
													return apply($.get(proposal));
												});

												$.append($$anchor, article);
											}),
											'each',
											AdminIngest,
											417,
											8
										);

										$.template_effect(() => {
											$.set_text(text_15, `${$.get(group).label ?? ''} `);
											$.set_text(text_16, $.get(group).rows.length);
										});

										$.append($$anchor, fragment_11);
									};

									$.add_svelte_meta(
										() => $.if(node_15, ($$render) => {
											if ($.get(group).rows.length > 0) $$render(consequent_18);
										}),
										'if',
										AdminIngest,
										381,
										6
									);
								}

								$.append($$anchor, fragment_10);
							}
						),
						'each',
						AdminIngest,
						380,
						4
					);

					$.append($$anchor, fragment_9);
				};

				$.add_svelte_meta(
					() => $.if(node_13, ($$render) => {
						if ($.get(loading)) $$render(consequent_13); else if ($.strict_equals($.get(proposals).length, 0)) $$render(consequent_14, 1); else $$render(alternate_4, -1);
					}),
					'if',
					AdminIngest,
					372,
					2
				);
			}

			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(isAdmin)) $$render(consequent); else $$render(alternate_5, -1);
			}),
			'if',
			AdminIngest,
			247,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);